import { render, staticRenderFns } from "./CadastroAluno.vue?vue&type=template&id=4af92dd8&scoped=true&"
import script from "./CadastroAluno.vue?vue&type=script&lang=js&"
export * from "./CadastroAluno.vue?vue&type=script&lang=js&"
import style0 from "./CadastroAluno.vue?vue&type=style&index=0&id=4af92dd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af92dd8",
  null
  
)

export default component.exports